import { useEffect, useState } from 'react'
import { EnvTypes } from '../types/andTypes'

const useEnvironmentType = (): EnvTypes => {
  const [env, setEnv] = useState(EnvTypes.PRODUCTION)
  useEffect(() => {
    if (
      window.location.href.includes('http://localhost:') ||
      window.location.href.includes('dev')
    ) {
      setEnv(EnvTypes.DEV)
    } else if (window.location.href.includes('stage')) {
      setEnv(EnvTypes.STAGING)
    } else {
      setEnv(EnvTypes.PRODUCTION)
    }
  }, [window.location.href])
  return env
}

export default useEnvironmentType
